import { useMutation } from '@tanstack/react-query';
import { queryFetch } from '@services/api';
import { useJobRefetch } from '@hooks/job/refetch';
import { InternalScheduleRespSuccess, InternalScheduleUpdateCrewMembersReq } from './types';
import { camelToSnakeCase } from '@utils/textHelpers';

export const useUpdateInternalScheduleCrewMembers = ({
  callback,
}: {
  callback: (data: InternalScheduleRespSuccess) => void;
}) => {
  const { refetch } = useJobRefetch({ schedule: { type: 'internal', action: 'update' } });

  const { mutate, isPending } = useMutation({
    mutationFn: ({
      scheduleId,
      crewChangeScope,
      actionType,
      confirmed,
      ...schedule
    }: InternalScheduleUpdateCrewMembersReq): Promise<InternalScheduleRespSuccess> => {
      return queryFetch({
        url: `schedules/${scheduleId}`,
        data: {
          schedule: { ...schedule, crewChangeScope: camelToSnakeCase(crewChangeScope) },
          action_type: actionType,
          confirmed,
        },
        opt: { method: 'PUT' },
      });
    },
    onError: (err) => {
      console.error(err);
    },
    onSuccess: async ({ success }) => {
      if (!success) return;
      await refetch();
    },
    onSettled: (data) => {
      if (data) callback(data);
    },
  });

  return {
    mutate,
    isLoading: isPending,
  };
};
